import { z } from 'zod'
import { Model } from './architecture'
import { Stars } from './Stars'

export const ListOfStarsValidation = z.object({
  list: z.instanceof(Stars, { message: '[ListOfStars] list is required' }).array(),
})

export class ListOfStars extends Model {
  static create({ list }: z.infer<typeof ListOfStarsValidation>) {
    ListOfStarsValidation.parse({ list })
    return new ListOfStars(list)
  }

  static fromLegacyContext({ stars }: { stars?: string[] }) {
    return ListOfStars.create({
      list:
        stars
          ?.map(s => {
            try {
              return Stars.create({ value: parseInt(s) })
            } catch {
              return null
            }
          })
          .filter((s): s is Stars => s !== null) ?? [],
    })
  }

  static fromJSON({ json }: { json: ReturnType<ListOfStars['toJSON']> }) {
    return ListOfStars.create({
      list: json.list
        .map(starJson => {
          try {
            return Stars.create({ value: starJson.value })
          } catch {
            return null
          }
        })
        .filter((s): s is Stars => s !== null),
    })
  }

  constructor(private readonly _list: Stars[]) {
    super()
  }

  get list() {
    return this._list
  } // prettier-ignore

  toJSON() {
    return { list: this._list.map(item => item.toJSON()) }
  }

  map<T>(fn: (star: Stars) => T) {
    return this._list.map(fn)
  }
}
